import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRmUAAABXRUJQVlA4TFkAAAAvB0ABAM1VICICHgiACQMAAICFkgMAIEiIExw8AkAAAAAAAAAAAAAAACTAAYADAAAI/DjkYH8AbsMBABARSfAn7PwQ8LnVsrcDh54+uq/XLzGHNRnlZrZSAAA=", blurWidth: 8, blurHeight: 6 }
